import React from 'react';
import { Field } from 'formik';
import { paths } from 'config/path_helpers';

export const EuPrivacyPolicy: React.FC = () => {
  return (
    <div className="form-group">
      <label className="control-label checkbox u-margin-L-m text-gray-light font-weight-normal">
        <Field component="input" type="checkbox" name="termsAndPolicyAccepted" />
        <span>
          I consent to Magoosh using my personal data to create my account and record my progress, and to
          receiving study tips, promotions, and other useful opportunities. We promise to treat your data with
          the utmost care and you can unsubscribe from messaging at any time. By clicking &quot;Complete
          Order&quot;, you agree to our{' '}
          <a href={paths.terms()} target="_blank" rel="noopener noreferrer">
            Terms of Use
          </a>{' '}
          and{' '}
          <a href={paths.privacy()} target="_blank" rel="noopener noreferrer">
            Privacy Policy.
          </a>
        </span>
      </label>
    </div>
  );
};

export default EuPrivacyPolicy;
